import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Check from '@material-ui/icons/Check';

import { translate } from 'services/i18nService';

import styles from './index.css';


const PurchaseSuccessfulNotification = (props) => {
  const { videoLoaded } = props;

  const classes = classNames({
    [styles.purchaseSuccessfulNotification]: true,
    [styles.fadeOut]: videoLoaded,
  });

  return (
    <div className={classes}>
      <Check />
      <div>
        {translate('v2profile.my.shop.success')}
      </div>
    </div>
  );
};

PurchaseSuccessfulNotification.propTypes = {
  videoLoaded: PropTypes.bool.isRequired,
};

export default memo(PurchaseSuccessfulNotification);
